<template>
  <div class="page-header">
    <h1 class="search-results-title">
      {{ $t('search.search_results', { keywords: query }) }}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'SearchResultsTitle',
  props: {
    query: {
      type: String,
      default: '',
    },
  },
}
</script>
